import React, { Component } from 'react'
import MasterTemplatePageSF from '../MasterTemplatePageSF.js'

class MasterLoanAgrNbfcPageSF extends Component {
  render() {
    return (
      <MasterTemplatePageSF
        {...this.props}
        templateCode='loan_agreement_nbfc'
        title='NBFC terms'
        activeTab='loanAgreement'
        navConfig={{ loanAgrPage: 'loanSpecific', subNavType: 'loanSpecific', subNavPage: 'nbfc' }}
      />
    )
  }
}

export default MasterLoanAgrNbfcPageSF
